<template>
  <el-dialog
    v-if="visibles"
    
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    center
    top="5vh"
    :width="'60%'"
    class="electricDialog"
  >
    <dialog-header
      slot="title"
      :icon="'icon-charge-detail'"
      :title="$t('appManagement.detailDilago.appTitle')"
      @close="closeDialog"
    />
    <div v-loading="listLoading" style="height: 80vh">
      <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
        <vue-linetitle
          :title="$t('appManagement.detailDilago.personTitle')"
          :icon-config="{icon: 'peopleMessage'}">
          <div style="display:flex;">
            <div style="flex:1;" class="person-p">
              <p>
                <span>{{ $t('appManagement.realName') }}: {{ formInfo.realName }}</span>
              </p>
              <p>
                <span>{{ $t('public.mobile') }}: {{ formInfo.mobile }}</span>
              </p>
              <p>
                <span>{{ $t('appManagement.nickName') }}: {{ formInfo.nickName }}</span>
              </p>
              <p class="wl-flex-p">
                <span>{{ $t('appManagement.gender') }}: {{ formInfo.gender }}</span>
                <span>{{ $t('appManagement.birthDate') }}: {{ formInfo.birthDate }}</span>
              </p>
            </div>
            <div :class="['person-img',formInfo.url ? formInfo.url : 'default-img']">
              <img :src="formInfo.url">
            </div>
          </div>
        </vue-linetitle>
        <vue-linetitle
          :title="$t('appManagement.detailDilago.carTitle')"
          :icon-config="{icon: 'approve-car-info'}">
          <div style="height:15vh;">
            <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
              <div :style="'min-height: '+Math.ceil(carList.length/2)*55+'px'">
                <div
                  v-for="(item,index) in carList"
                  :key="index"
                  class="car-app-list"
                >
                  <vue-licenseplate
                    :licensepalte="item.licensePlate"
                    :area="item.areaName"
                  />
                  <span class="car-app">{{ $t('appManagement.detailDilago.maxSpeed') }}：{{ item.maxSpeed ? item.maxSpeed+'km/h' : '/' }} </span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </vue-linetitle>
        <vue-linetitle
          :title="$t('appManagement.detailDilago.notifyTitle')"
          :icon-config="{icon: 'car-other'}">
          <p class="wl-flex-p">
            <span>{{ $t('appManagement.detailDilago.securityModeAlarm') }}: <i :class="[notifyList.securityModeAlarm === 0?'red':notifyList.securityModeAlarm === 1?'blue':'']">{{ notifyList.securityModeAlarm | switchText }}</i></span>
            <span>{{ $t('appManagement.detailDilago.deviceUnplugReminder') }}: <i :class="[notifyList.deviceUnplugReminder === 0?'red':notifyList.deviceUnplugReminder === 1?'blue':'']">{{ notifyList.deviceUnplugReminder | switchText }}</i></span>
          </p>
          <p class="wl-flex-p">
            <span>{{ $t('appManagement.detailDilago.safetyReminder') }}: <i :class="[notifyList.safetyReminder === 0?'red':notifyList.safetyReminder === 1?'blue':'']">{{ notifyList.safetyReminder | switchText }}</i></span>
            <span>{{ $t('appManagement.detailDilago.geoFenceReminder') }}: <i :class="[notifyList.geoFenceReminder === 0?'red':notifyList.geoFenceReminder === 1?'blue':'']">{{ notifyList.geoFenceReminder | switchText }}</i></span>
          </p>
          <p class="wl-flex-p">
            <span>{{ $t('appManagement.detailDilago.deviceOfflineReminder') }}: <i :class="[notifyList.deviceOfflineReminder === 0?'red':notifyList.deviceOfflineReminder === 1?'blue':'']">{{ notifyList.deviceOfflineReminder | switchText }}</i></span>
            <span>{{ $t('appManagement.detailDilago.activityReminder') }}: <i :class="[notifyList.activityReminder === 0?'red':notifyList.activityReminder === 1?'blue':'']">{{ notifyList.activityReminder | switchText }}</i></span>
          </p>
          <p class="wl-flex-p">
            <span>{{ $t('appManagement.detailDilago.systemMessage') }}: <i :class="[notifyList.systemMessage === 0?'red':notifyList.systemMessage === 1?'blue':'']">{{ notifyList.systemMessage | switchText }}</i></span>
            <span>{{ $t('appManagement.detailDilago.overSpeedAlarm') }}: <i :class="[notifyList.overSpeedAlarm === 0?'red':notifyList.overSpeedAlarm === 1?'blue':'']">{{ notifyList.overSpeedAlarm | switchText }}</i></span>
          </p>
        </vue-linetitle>
        <vue-linetitle
          :title="$t('public.note')"
          :icon-config="{icon: 'approve-car'}">
            <div style="min-height: 50px" class="remark-class">
             
              <el-timeline style="padding-left: 15px">
                <el-timeline-item
                  v-for="(item, index) in logList"
                  :key="index"
                  color="#409eff"
                placement="top"
                hide-timestamp >
                  <p style="padding: 3px 0;margin-top: 0">
                   <span style="color: #909399"> {{ item.createdOn }} </span>
                    {{ item.createdBy  }}</p>
                  <el-card 
                  :body-style="{padding: '10px'}"
                  style="width: calc(100% - 30px)">
                    <h4>
                      <span :style="{color: item.state === 1 ? '#ff0000':'#409EFF'}"> {{item.state === 1? $t('public.ban'):$t("public.enable")}}</span>
                    </h4>
                    <p>{{ item.note }}</p>
                  </el-card>
                  
                </el-timeline-item>
              </el-timeline>
              <div v-show="logList.length==0" style="text-align: center;margin-top: 30px">{{ $t('book.historyTrack.noData') }}</div>
            </div>
        </vue-linetitle>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { getCarlist, getNotifylist, getDisableLog } from '@/api/userCenter/appManagement'

export default {
  name: 'AddUpdateDialog',
  filters: {
    switchText(val) {
      return val === 0 ? vm.$t('appManagement.detailDilago.off') : val === 1 ? vm.$t('appManagement.detailDilago.open') : ''
    }
  },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      carList: [],
      notifyList: {},
      formInfo: {},
      listLoading: false,
       logList: []
      
    }
  },
  computed: {
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = this.data
        this.listLoading = false
        this.load()
      }
    }
  },
  created() {
  },
  methods: {
    load(){
      this.getCar()
      this.getNotify()
      this.getDisable()
    },
    // 关闭
    closeDialog() {
      this.notifyList = []
      this.carList = []
      this.logList = []
      this.$emit('update:visibles', false)
    },
    // 获取车辆
    getCar() {
      getCarlist(this.data.appUserId).then(({ data }) => {
        if (data.code === 0) {
          this.carList = data.data || []
        }
      })
    },
    getNotify() {
      getNotifylist(this.data.appUserId).then(({ data }) => {
        if (data.code === 0 && data.data) {
          this.notifyList = data.data[0] || []
        }
      })
    },
    getDisable() {
      getDisableLog(this.data.appUserId).then(({data})=> {
        if (data.code === 0 && data.data){
          this.logList = data.data || []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-style: normal;
}
.remark-class{
  p,h4{
    margin: 4px 0;
  }
}
.wl-flex-p{
  display: flex;
  span{
    flex: 1;
  }
}
.car-app-list{
  float: left;
  display: flex;
  margin-bottom:5px;
  width: 50%;
}
.car-app{
  line-height: 50px;
  margin-left: 30px;
  flex: 1;
}
.red{
  color: #ff0000;
}
.blue{
  color: #409EFF;
}
.person-p p{
  margin-bottom: 20px;
}
.person-img{
  width:127px;
  height: 156px;
  margin-right: 50px;
  img{
    width:127px;
    height: 156px;
  }
}
.default-img{
  background: url('../../../../assets/defaultImg.png') no-repeat;
}

</style>


